import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";

export const SquareMeterSuffix = (
  <Typography>
    m<sup>2</sup>
  </Typography>
);
